import '../../assets/scss/content/content.scss'
import {ImgButton} from '../../components/core/button'
import {ContentEmptyIcon, PlusIcon} from '../../icons'
import {useDispatch, useSelector} from 'react-redux'
import classNames from 'classnames'
import {setActivePopup} from '../../stores/popup'
import {useNamespaceTranslations} from '../../utils/hooks/useNamespacesTranslations'

const EmptyContent = ({message, hideButton, buttonText, onclick, icon, showIcon = true, isDisabled = false}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const translations = useNamespaceTranslations('resources')
    const modalTypes = useNamespaceTranslations('modals')
    const dispatch = useDispatch()
    const openModal = () => {
        dispatch(setActivePopup(modalTypes.uptime_monitoring.addResource))
    }
    return (
        <div className={classNames('empty-content-body', {
            dark: isDarkMode
        })}>
            {icon || <ContentEmptyIcon/>}
            <p>{message || translations.content_empty}</p>
            {!hideButton && (
                <ImgButton onClick={onclick || openModal} className={classNames({
                    'button-centered': !showIcon
                })} disabled={isDisabled}>
                    {buttonText || translations.add_monitoring}
                    {showIcon && <span><PlusIcon/></span>}
                </ImgButton>
            )}
        </div>
    )
}

export default EmptyContent
